import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Output() loggedIn: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() redirectToHome: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() username;
  
  @Input() isLoggedIn;
  @Input() showLogoutBtn = false;
  
  constructor() { }

  ngOnInit(): void {
  }

  logout() {
    this.loggedIn.emit(false);
  }

  goToHome() {
    this.redirectToHome.emit(true);
  }
}
